import { useCallback, useEffect, useState } from 'react';
import { Report } from '../types';
import { ModuleActivity, aktivitaetAusProjektJson, mergeAktivitaet } from '../services/moduleActivity';
import { fetchModuleActivity } from '../services/moduleActivityService';

/**
 * Letzte Aktivitaet je Kachel des Projekt-Hubs. Tabellenwerte werden je
 * Projekt geladen (der Hub wird beim Rueckweg aus einem Modul neu gemountet
 * und fragt dann frisch); die JSON-Werte (Vorankuendigung, Unterlage,
 * Archiv-Anteile) folgen dem Report live.
 *
 * `reload` ist fuer Aenderungen, die der Hub selbst ausloest, ohne sich zu
 * verlassen: der Sendeverlauf ist ein Overlay UEBER dem Hub, ein
 * Wiederholungsversand dort schreibt `email_logs`, und ohne Neuladen bliebe
 * „Zuletzt gesendet" beim alten Datum stehen.
 *
 * Der Ladestand traegt das Projekt, fuer das er gilt: beim Projektwechsel
 * zeigt der Hub so nie die Daten des vorigen Projekts, ohne dass der Effekt
 * synchron zuruecksetzen muesste.
 */
export const useModuleActivity = (projectId: string | undefined, report: Report): { activity: ModuleActivity; reload: () => void } => {
    const [geladen, setGeladen] = useState<{ fuer: string | undefined; werte: ModuleActivity }>({ fuer: undefined, werte: {} });
    const [lauf, setLauf] = useState(0);
    const reload = useCallback(() => setLauf(n => n + 1), []);

    useEffect(() => {
        let aktiv = true;
        if (!projectId || projectId === 'temp-id') return;
        fetchModuleActivity(projectId)
            .then(werte => { if (aktiv) setGeladen({ fuer: projectId, werte }); })
            .catch(e => console.warn('Modul-Aktivität konnte nicht geladen werden:', e));
        return () => { aktiv = false; };
    }, [projectId, lauf]);

    const ausTabellen = geladen.fuer === projectId ? geladen.werte : {};
    return { activity: mergeAktivitaet(ausTabellen, aktivitaetAusProjektJson(report)), reload };
};
